import { useState } from "react";
import PrevisionFamilleView from "./PrevisionFamilleView"; // ← ajouter cet import
import PrevisionFView from "./PrevisionFView";
import PrevisionSousFamilleView from "./PrevisionSousFamilleView";

type ViewMode = "horizon" | "sousfamille" | "famille"; // ← ajouter "famille"

const PrevisionFContainer: React.FC = () => {
  const [view, setView] = useState<ViewMode>("horizon");

  if (view === "sousfamille") {
  return (
    <PrevisionSousFamilleView
      onSwitchToHorizon={() => setView("horizon")}
      onSwitchToFamille={() => setView("famille")}
      onSwitchToFiltre={() => setView("horizon")}   // ← ajouter (Filtre = vue horizon)
    />
  );
}

  if (view === "famille") {
  return (
    <PrevisionFamilleView
      onSwitchToHorizon={() => setView("horizon")}
      onSwitchToSousFamille={() => setView("sousfamille")}  // ← ajouter
    />
  );
}

  return (
    <PrevisionFView
      onSwitchToSousFamille={() => setView("sousfamille")}
      onSwitchToFamille={() => setView("famille")} // ← ajouter ce prop
    />
  );
};
export default PrevisionFContainer;
